import { type Accessor, createMemo } from 'solid-js'
import { useFormContext } from '~/components/Form'

/**
 * Error visible de un campo: el que llega por props manda, y si no hay, el que
 * publica el `<Form>` para ese `name`.
 *
 * Estaba copiado tal cual en nueve componentes, siempre como
 * `props.error ?? formCtx?.error(name)`. Ese `??` tiene un fallo: sólo filtra
 * `null` y `undefined`, así que un `error=""` —lo que sale de limpiar el estado
 * de una página— ganaba la partida y **tapaba** el error del formulario. Aquí la
 * cadena vacía cuenta como "sin error".
 *
 * @param name  Nombre del campo con el que el `<Form>` lo indexa
 * @param own   Error recibido por props, si el consumidor lo pasa a mano
 */
export function useFieldError(name: () => string | undefined, own: () => string | undefined = () => undefined): Accessor<string | undefined> {
  const formCtx = useFormContext()

  return createMemo(() => {
    const explicit = own()
    if (explicit) return explicit

    const field = name()
    if (!field) return undefined
    return formCtx?.error(field) || undefined
  })
}

export default useFieldError
